import React from 'react';
import MuiAppBar from '@material-ui/core/AppBar';

const AppBar = props => <MuiAppBar {...props} />;

AppBar.muiName = 'AppBar';

export default AppBar;
